import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LogoBomAdmin        from 'images/logo-bom-admin.png'

export default (props) => {
  return (
    <div className="powered-by-bom-admin">
      <strong> Powered by </strong>
      <img className="bom-admin-logo" 
        src={LogoBomAdmin} 
        alt="Logo bom admin" />
    </div>
  );
};
